import { render, staticRenderFns } from "./XingShareButton.vue?vue&type=template&id=2bc84e5d&scoped=true&"
import script from "./XingShareButton.vue?vue&type=script&lang=js&"
export * from "./XingShareButton.vue?vue&type=script&lang=js&"
import style0 from "./XingShareButton.vue?vue&type=style&index=0&id=2bc84e5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc84e5d",
  null
  
)

export default component.exports